import styled from 'styled-components';
import { color } from '../../../../atoms/colors';
import { font } from '../../../../atoms/typography';

import { spacing } from '../../../../atoms/spacing';
import {
  defaultStyles,
  variants,
  sizes,
} from '../../../CallToAction/styles/CallToAction.styled';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  .hs-form-html {
    .hsfc-Step__Content {
      padding: ${spacing[0]} !important;
    }
    .hsfc-TextInput {
      display: flex;
      align-items: center;
      gap: ${spacing[8]};
      padding: ${spacing[10]} ${spacing[14]};
      border-radius: ${spacing[8]};
      border: 1px solid ${color.darkBlue[200]};
      background: ${color.common.white};
      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
      ${font('text', 'md', '400')}
      color: ${color.darkBlue[600]};
    }
    .hsfc-PhoneInput__FlagAndCaret {
      border-top-left-radius: ${spacing[8]} !important;
      border-bottom-left-radius: ${spacing[8]} !important;
    }
    .hsfc-Button {
      width: 100%;
      text-align: center;
      transition: all 250ms ease-in-out;
      ${defaultStyles}
      ${variants['Filled - Dark']}
      ${sizes.xxl}
      margin-top: 12px;
      &:not([disabled]):hover {
        color: ${color.common.white};
        background: ${color.darkBlue[700]};
        border: 1px solid ${color.darkBlue[700]};
      }
    }
  }
`;
